import { NavigationGuardNext, Route } from 'vue-router'

import store from '@/store'
import StorageService from '@/services/storage-service'

function checkExpirationGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  const isAuthenticated = store.getters['auth/isAuthenticated']
  const isExpired = store.getters['subscription/isExpired']
  const redirectedToBilling = to.path.includes('billing')
  const redirectToExpiredPage = to.name === 'billing:expired'
  const inGrace = store.getters['subscription/inGrace']
  const graceType = store.getters['subscription/graceType']
  const firstLoad = !from.matched?.length
  const hideGraceAlert = StorageService.getItem('okmenu_hide_grace', false, store.getters['auth/user']?.id)
  const graceRedirect = inGrace && graceType === 'recurring' && firstLoad && !hideGraceAlert

  if ((redirectedToBilling && !firstLoad && !graceRedirect) || redirectToExpiredPage) {
    return next()
  }

  if (isAuthenticated && (isExpired || graceRedirect)) {
    store.commit('navigation/SET_PREV_ROUTE', to)
    return next({ name: 'billing:expired' })
  }

  return next()
}

export default checkExpirationGuard
